import store from './store';

export default store;



// WEBPACK FOOTER //
// ./src/app/custom-cards/index.js